var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.02,
    height: 31.568,
    viewBox: "0 0 40.02 31.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(4595.969 1137.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(-4595.969 -1137.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M-2623.4-1544.874a7.966,7.966,0,0,1-1.074-.074c-.032,0,0-1.5,0-1.5a5.823,5.823,0,0,0,6.7-4.686c.476-2.368-.416-5.495-4.5-6.516l-.539-.135-.026-.554a5.866,5.866,0,0,0-2.516-4.45,5.664,5.664,0,0,0-4.928-.858l-.493.149-.315-.407a6.15,6.15,0,0,0-5.647-2.739,5.686,5.686,0,0,0-4.352,2.61l-.25.511-.559-.1a6.579,6.579,0,0,0-5.374,1.024,5.644,5.644,0,0,0-2.111,4.162l-.041.579-.571.1a5.9,5.9,0,0,0-4.682,6.256c.235,3.093,3.181,5.352,6.84,4.977v1.619c-5.725.047-8.1-3.446-8.329-6.482a7.453,7.453,0,0,1,5.351-7.715,7.026,7.026,0,0,1,2.629-4.68,7.957,7.957,0,0,1,6.039-1.4,7.442,7.442,0,0,1,5.256-2.95,7.61,7.61,0,0,1,6.667,2.924,7.176,7.176,0,0,1,5.729,1.2,7.419,7.419,0,0,1,3.1,5.054,6.832,6.832,0,0,1,5.083,8.115A7.31,7.31,0,0,1-2623.4-1544.874Z",
    transform: "translate(2656.193 1568.168)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(10.61 8.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M18.907-151.248a3.766,3.766,0,0,1-1.876-.448,3.007,3.007,0,0,1-1.223-1.281,4.28,4.28,0,0,1-.427-1.975v-2.727a4.3,4.3,0,0,1,.427-1.978,3,3,0,0,1,1.223-1.285,3.766,3.766,0,0,1,1.876-.448,3.434,3.434,0,0,1,1.623.383,3.276,3.276,0,0,1,1.21,1.1A4.456,4.456,0,0,1,22.4-158.2H20.718a2.382,2.382,0,0,0-.39-.837,1.858,1.858,0,0,0-.632-.55,1.677,1.677,0,0,0-.789-.191,1.824,1.824,0,0,0-.981.256,1.669,1.669,0,0,0-.636.728,2.592,2.592,0,0,0-.222,1.114v2.727a2.574,2.574,0,0,0,.222,1.107,1.647,1.647,0,0,0,.636.724,1.843,1.843,0,0,0,.981.253,1.769,1.769,0,0,0,.8-.181,1.768,1.768,0,0,0,.632-.536,2.258,2.258,0,0,0,.383-.854H22.4a4.392,4.392,0,0,1-.663,1.7,3.352,3.352,0,0,1-1.21,1.1A3.388,3.388,0,0,1,18.907-151.248Zm8.265,0a3.735,3.735,0,0,1-1.866-.454,3.146,3.146,0,0,1-1.251-1.285,4.017,4.017,0,0,1-.444-1.924v-2.816a4.017,4.017,0,0,1,.444-1.924,3.146,3.146,0,0,1,1.251-1.285,3.735,3.735,0,0,1,1.866-.454,3.754,3.754,0,0,1,1.869.454,3.118,3.118,0,0,1,1.251,1.285,4.042,4.042,0,0,1,.441,1.924v2.816a4.042,4.042,0,0,1-.441,1.924,3.118,3.118,0,0,1-1.251,1.285A3.754,3.754,0,0,1,27.172-151.248Zm0-1.626a1.943,1.943,0,0,0,.987-.246,1.665,1.665,0,0,0,.659-.7,2.252,2.252,0,0,0,.232-1.046v-2.911a2.273,2.273,0,0,0-.232-1.049,1.661,1.661,0,0,0-.659-.7,1.943,1.943,0,0,0-.987-.246,1.924,1.924,0,0,0-.984.246,1.667,1.667,0,0,0-.656.7,2.273,2.273,0,0,0-.232,1.049v2.911a2.252,2.252,0,0,0,.232,1.046,1.672,1.672,0,0,0,.656.7A1.924,1.924,0,0,0,27.172-152.874Z",
    transform: "translate(-15.381 161.389)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M4.219-64.093v-.335a1.959,1.959,0,0,1,.087-.618,1.553,1.553,0,0,1,.276-.493,4.245,4.245,0,0,1,.655-.592,4.852,4.852,0,0,0,.442-.378.946.946,0,0,0,.163-.223.514.514,0,0,0,.054-.233q0-.417-.5-.417a1.505,1.505,0,0,0-.965.37v-1.018a2.925,2.925,0,0,1,.649-.245,2.735,2.735,0,0,1,.62-.07,1.552,1.552,0,0,1,1.056.327,1.152,1.152,0,0,1,.373.916,1.427,1.427,0,0,1-.2.767,2.315,2.315,0,0,1-.726.656,4.8,4.8,0,0,0-.538.383.341.341,0,0,0-.136.206H7.164v1Z",
    transform: "translate(12.566 73.945)",
    fill: "#084688"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M-2256.538-1220.248h-2.839v5.42h-1.947l3.4,3.707,3.449-3.707h-2.065Z",
    transform: "translate(2285.886 1241.889)",
    fill: "#084688",
    stroke: "#084688",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M-2256.538-1220.248h-2.839v5.42h-1.947l3.4,3.707,3.449-3.707h-2.065Z",
    transform: "translate(2277.909 1240.459)",
    fill: "#084688",
    stroke: "#084688",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M-2256.538-1220.248h-2.839v5.42h-1.947l3.4,3.707,3.449-3.707h-2.065Z",
    transform: "translate(2270.071 1241.952)",
    fill: "#084688",
    stroke: "#084688",
    strokeWidth: 1
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/CO2.8d3fad51.svg";
export { ForwardRef as ReactComponent };